import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { SIZES, KINDS } from '../helper';
import { kindMap } from './helper';
import ScopedCssBaseline from '../StyleBase/ScopedCssBaseline';
const flagWidth = '8px';

const useKindStyle = kind => kind && css(["border:1px solid var(--neutral-border);&::before{background-color:var(", ");}svg{fill:var(", ");}"], kindMap.get(kind).color, kindMap.get(kind).color);

const resolvePadding = size => {
  const padding = {
    lg: "\n      var(--size-spacing-05)\n      var(--size-spacing-05)\n      var(--size-spacing-05)\n      calc(var(--size-spacing-05) + ".concat(flagWidth, ")\n    "),
    md: "\n      var(--size-spacing-03)\n      var(--size-spacing-04)\n      var(--size-spacing-03)\n      calc(var(--size-spacing-04) + ".concat(flagWidth, ")\n    "),
    sm: "\n      var(--size-spacing-03)\n      var(--size-spacing-02)\n      var(--size-spacing-03)\n      calc(var(--size-spacing-02) + ".concat(flagWidth, ")\n    ")
  };
  return padding[size] ? padding[size] : padding.lg;
};

const Root = styled.div.withConfig({
  displayName: "MessageContainer__Root",
  componentId: "sc-1cxk6xn-0"
})(["", " background-color:var(--neutral-surface);width:100%;display:", ";border-radius:var(--border-radius-rounded);padding:", ";&::before{content:'';display:block;width:", ";position:absolute;left:0;top:-1px;height:calc(100% + 2px);border-radius:var(--border-radius-rounded) 0 0 var(--border-radius-rounded);background-color:transparent;}", ""], ScopedCssBaseline, _ref => {
  let {
    customizable
  } = _ref;
  return customizable ? 'block' : 'flex';
}, _ref2 => {
  let {
    size
  } = _ref2;
  return resolvePadding(size);
}, flagWidth, _ref3 => {
  let {
    kindMessage
  } = _ref3;
  return kindMessage && useKindStyle(kindMessage);
});
const MessageContainer = /*#__PURE__*/forwardRef((_ref4, ref) => {
  let {
    children
  } = _ref4,
      rest = _objectWithoutPropertiesLoose(_ref4, _excluded);

  return /*#__PURE__*/React.createElement(Root, _extends({
    ref: ref
  }, rest), children);
});
MessageContainer.display = 'MessageContainer';
MessageContainer.defaultProps = {
  children: null,
  size: SIZES.LG,
  kindMessage: KINDS.DEFAULT,
  customizable: false
};
MessageContainer.propTypes = {
  /**
   * @ignore
   * Sets the children internally by Toast or Snackbar.
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.array, PropTypes.node]),

  /**
   * @ignore
   * Set internally by Toast or Snackbar Component
   */
  size: PropTypes.oneOf([SIZES.SM, SIZES.MD, SIZES.LG]),

  /**
   * @ignore
   * Set internally by Toast or Snackbar Component
   */
  kindMessage: PropTypes.oneOf(Object.values(KINDS)),

  /**
   * @ignore
   * Set internally by Toast or Snackbar Component. Flag if container is customizable or not
   */
  customizable: PropTypes.bool
};
export default MessageContainer;